<template>
    <div>
        <div v-show="!loading">
            <label v-if="!selectedEan">
                {{ __("product.check_ean.check_existing_ean") }}
            </label>
            <label v-else>{{ __("product.check_ean.article_ean") }}</label>
            <div class="input-group w-lg-50">
                <input
                    ref="eanInput"
                    type="text"
                    class="form-control"
                    :placeholder="__('product.check_ean.ean_gtin')"
                    v-model="ean"
                    @keyup.enter="check()"
                />
                <div
                    v-if="!selectedEan"
                    class="btn btn-primary input-group-append"
                    @click="check()"
                >
                    <span><i class="fas fa-search"></i></span>
                </div>
            </div>
            <span v-if="this.errors.length > 0" class="mt-3 text-danger">{{
                this.errors[0][0]
            }}</span>
        </div>
        <div v-show="loading" class="text-center">
            <loading-barcode bg-class="bg-primary"></loading-barcode>
            <div class="mt-2" style="font-size: 1.6em">
                {{ __("actions.search") }} {{ ean }}
            </div>
        </div>

        <!--    UPDATE ARTICLE    -->
        <div
            v-if="
                response.exists !== undefined &&
                Object.keys(this.errors).length === 0 &&
                updateArticle
            "
        >
            <div v-if="!response.exists">
                <h5 class="my-6">
                    {{ __("product.check_ean.no_article_with_ean") }}
                </h5>
                <div class="h5 mb-6">
                    {{ __("product.check_ean.create_article") }}
                </div>
                <a :href="$route('article.create', { ean: this.ean })">
                    <button class="btn btn-primary">
                        <i class="fas fa-plus-square"></i
                        >{{ __("product.check_ean.create_article_button") }}
                    </button>
                </a>
            </div>
        </div>

        <div
            v-if="
                response.exists !== undefined &&
                Object.keys(this.errors).length === 0 &&
                showResults &&
                !updateArticle
            "
            class="my-12"
        >
            <div
                class="text-center border border-primary rounded p-md-12 w-xl-800px mx-auto"
            >
                <!--    Initial Check    -->
                <div v-if="firstCheck">
                    <div v-if="!response.exists">
                        <h5 class="mb-4 text-primary">
                            {{ __("product.check_ean.no_article_with_ean") }}
                        </h5>
                        <h5>{{ __("product.check_ean.create_article") }}</h5>
                        <div class="row flex-wrap justify-content-around mt-8">
                            <button
                                @click="resetEan"
                                class="btn btn-secondary mx-2 flex-1"
                            >
                                {{
                                    __("product.check_ean.no_enter_another_ean")
                                }}
                            </button>
                            <button
                                @click="useCustomEan"
                                class="btn btn-primary mx-2 flex-1"
                                type="button"
                            >
                                {{ __("product.check_ean.continue") }}
                            </button>
                        </div>
                    </div>
                    <div v-else>
                        <article-box
                            :article="response.article"
                            :article-found="true"
                        >
                            <h5>
                                {{
                                    __(
                                        "product.check_ean.select_article_assign_stores"
                                    )
                                }}
                            </h5>
                            <div
                                class="row flex-wrap justify-content-around mt-8"
                            >
                                <button
                                    @click="resetEan"
                                    class="btn btn-secondary mx-2 flex-1"
                                >
                                    {{
                                        __(
                                            "product.check_ean.no_enter_another_ean"
                                        )
                                    }}
                                </button>
                                <button
                                    @click="useFoundArticle"
                                    class="btn btn-primary mx-2 flex-1"
                                    type="button"
                                >
                                    {{ __("product.check_ean.continue") }}
                                </button>
                            </div>
                        </article-box>
                    </div>
                </div>

                <!--  Second Check  -->
                <div v-if="!firstCheck">
                    <div v-if="!response.exists">
                        <h5 class="mb-4 text-primary">
                            {{ __("product.check_ean.no_article_in_database") }}
                        </h5>
                        <h5>
                            {{
                                __("product.check_ean.create_article_with_ean")
                            }}
                        </h5>
                        <div class="row flex-wrap justify-content-around mt-8">
                            <button
                                @click="resetEan"
                                class="btn btn-secondary mx-2 flex-1"
                            >
                                {{
                                    __("product.check_ean.no_enter_another_ean")
                                }}
                            </button>
                            <button
                                @click="useCustomEan"
                                class="btn btn-primary mx-2 flex-1"
                                type="button"
                            >
                                {{ __("product.check_ean.continue") }}
                            </button>
                        </div>
                    </div>
                    <div v-else>
                        <h5 class="mb-4 text-primary">
                            {{ __("product.check_ean.article_found") }}
                        </h5>
                        <h5>{{ response.article.name }}</h5>
                        <img
                            class="w-50 mb-4"
                            :src="response.article.images[0].url"
                            :alt="__('general.article_image')"
                        />
                        <div class="h5">
                            {{
                                __(
                                    "product.check_ean.existing_articles_cannot_be_used"
                                )
                            }}
                        </div>
                        <div class="row flex-wrap justify-content-around mt-8">
                            <button
                                @click="resetEan"
                                class="btn btn-secondary mx-2 flex-1"
                            >
                                {{ __("product.check_ean.enter_other_ean") }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LoadingBarcode from "../Loading/LoadingBarcode";
import ArticleBox from "./ArticleBox";

export default {
    name: "CheckEan",

    components: {
        ArticleBox,
        LoadingBarcode,
    },

    props: {
        firstCheck: Boolean,
        presetEan: String,
        updateArticle: Boolean,
    },
    mounted() {
        if (this.presetEan) {
            this.ean = this.presetEan;
            this.check();
        }
    },
    data() {
        return {
            loading: false,
            ean: "",
            showResults: false,
            response: {},
            errors: {},
            form: {},
            selectedEan: "",
        };
    },

    methods: {
        async check() {
            this.loading = true;

            await axios
                .post(this.$route("check-ean"), {
                    ean: this.ean,
                })
                .then((response) => {
                    this.response = response.data;
                    this.errors = {};
                    this.showResults = true;
                    this.$refs.eanInput.disabled = true;

                    if (this.updateArticle) {
                        if (this.response.exists) {
                            this.selectedEan = this.response.article.ean;
                            this.useFoundArticle();
                        } else {
                            this.$refs.eanInput.disabled = false;
                        }
                    } else if (this.firstCheck && this.response.exists) {
                        this.selectedEan = this.response.article.ean;
                    } else if (!this.firstCheck && !this.response.exists) {
                        this.useCustomEan();
                        this.selectedEan = this.ean;
                    } else if (!this.firstCheck && this.response.exists) {
                        this.$emit("articleNotAllowed", true);
                    }
                })
                .catch((error) => {
                    if (error.response.status === 422) {
                        this.errors = error.response.data.errors.ean;
                    }
                });
            this.loading = false;
        },
        resetEan() {
            this.$refs.eanInput.disabled = false;
            this.selectedEan = "";
            this.showResults = false;
            this.ean = null;
            this.$emit("articleNotAllowed", false);
        },
        useCustomEan() {
            this.$emit("useCustomEan", this.ean);
            this.showResults = false;
            this.selectedEan = this.ean;
        },
        useFoundArticle() {
            this.$emit("useFoundArticle", this.response.article);
            this.showResults = false;
        },
    },
};
</script>
